import Requests from "../../../utils/Requests"
import Validation from '../../../data/validation/validation'
import { StringValidationRule } from '../../../data/validation/rules'
import { ScrollIntoFirstError } from '../../../utils/UIHelper'

const getDefaultState = () => {
    return {
        updating: false,
        changePassword: {
            currentPassword: "",
            newPassword: "",
            confirmNewPassword: ""
        },
        errors: {},
        showError: false,
        alertError: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.changePassword.currentPassword, (error) => errors.currentPassword = error, { min: { value: 6, error: "Too short" }, max: { value: 40, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.changePassword.newPassword, (error) => errors.newPassword = error, { min: { value: 6, error: "Too short" }, max: { value: 40, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.changePassword.confirmNewPassword, (error) => errors.confirmNewPassword = error, { min: { value: 6, error: "Too short" }, max: { value: 40, error: "Too long" } })

    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    }
    ScrollIntoFirstError(errors)
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}


const changePassword = instance => {

    instance.setState({
        ...instance.state,
        updating: true
    })

    Requests(instance.props)
        .withPost()
        .withData(instance.state.changePassword)
        .withUrl('/api/member/change-password')
        .withAuthorization(instance.props.auth.authorizationToken)
        .then(response => handleChangePasswordResponse(instance, response), error => handleError(instance, error))
}

const handleChangePasswordResponse = (instance, response) => {
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                updating: false,
                changePassword: {
                    currentPassword: "",
                    newPassword: "",
                    confirmNewPassword: ""
                },
                flag: {
                    type: "success",
                    text: "Updated Successfully"
                }
            })
            break;
        default:
            instance.setState({
                ...instance.state,
                updating: false
            })
            alert(response.message)
    }
}

const handleError = (instance, error) => {
    instance.setState({
        ...instance.state,
        updating: false,
        flag: {
            type: "",
            text: ""
        }
    })

    alert(error)

}

const Service = instance => {
    return {
        changePassword: () => changePassword(instance),
        isValid: () => isValid(instance),
        getDefaultState: () => getDefaultState()
    }
}

export default Service